import { ResponseWrapper } from "@teamprevent/common/utils";
import * as moment from "moment";

import axios from "axios";

import { PartiallyMatchedEmployeeDetailModel } from "../model";

class PartiallyMatchedReferralApi {

    private readonly apiUrl = "/api/partiallymatchedreferral";

    public async detail(customerId: string, id: string): Promise<ResponseWrapper<PartiallyMatchedEmployeeDetailModel>> {
        const response = await axios.post(`${this.apiUrl}/${customerId}/${id}`);
        const data = response.data as ResponseWrapper<PartiallyMatchedEmployeeDetailModel>;
        return { ...data, data: this.parseModel(data.data) };
    }

    public async rerun(customerId: string, id: string): Promise<ResponseWrapper<PartiallyMatchedEmployeeDetailModel>> {
        const response = await axios.post(`${this.apiUrl}/${customerId}/${id}/rerun`);
        const data = response.data as ResponseWrapper<PartiallyMatchedEmployeeDetailModel>;
        return { ...data, data: this.parseModel(data.data) };
    }

    public async match(customerId: string, id: string, employeeRecordCustomerId: string, employeeRecordId: string): Promise<ResponseWrapper<boolean>> {
        const response = await axios.post(`${this.apiUrl}/${customerId}/${id}/match`, { customerId: employeeRecordCustomerId, employeeRecordId });
        const data = response.data as ResponseWrapper<boolean>;
        return data;
    }

    public async matchToNewEmployeeRecord(customerId: string, id: string): Promise<ResponseWrapper<boolean>> {
        const response = await axios.post(`${this.apiUrl}/${customerId}/${id}/matchToNewEmployeeRecord`);
        const data = response.data as ResponseWrapper<boolean>;
        return data;
    }

    private parseModel(model: PartiallyMatchedEmployeeDetailModel): PartiallyMatchedEmployeeDetailModel {
        return {
            ...model,
            dateOfBirth: model.dateOfBirth && moment(model.dateOfBirth, "YYYY-MM-DD"),
            partialMatchEmployeeRecords: model.partialMatchEmployeeRecords.map(partialMatch =>
                ({ ...partialMatch, dateOfBirth: partialMatch.dateOfBirth && moment(partialMatch.dateOfBirth, "YYYY-MM-DD") }))
        };
    }
}

export default new PartiallyMatchedReferralApi();
